export default class Accordion {
  constructor( node ) {
    this.accordions = node.querySelectorAll( '.accordion__items' );
    this.initClickEventHandler();
  }
  initClickEventHandler() {
    for ( let accordion of this.accordions ) {
      const items = accordion.children;
      for ( const item of items ) {

        item.children[ 0 ].addEventListener( 'click', () => {
          this.openCloseAccordion( item );
        });

        item.addEventListener( 'keydown', ( e ) => {
          const key = e.keyCode;
          const id = parseInt( item.getAttribute( 'data-id' ));

          switch ( key ) {
          // up and down
          case 38:
          case 40: {
            this.setFocus( accordion, id, key );
            break;
          }
          // space and enter
          case 32:
          case 13: {
            e.stopPropagation();
            e.preventDefault();
            this.openCloseAccordion( item );
            break;
          }
          }
        });
      }
    }
  }
  openCloseAccordion( item ) {
    item.classList.toggle( 'accordion__item--open' );

    if ( item.classList.contains( 'accordion__item--open' )) {
      item.children[ 0 ].children[ 1 ].classList.remove( 'collapsed' );
      item.setAttribute( 'aria-expanded', 'true' );
      item.children[ 1 ].setAttribute( 'aria-hidden', 'false' );
    } else {
      item.children[ 0 ].children[ 1 ].classList.add( 'collapsed' );
      item.setAttribute( 'aria-expanded', 'false' );
      item.children[ 1 ].setAttribute( 'aria-hidden', 'true' );
    }
  }
  setFocus( items, id, key ) {
    if ( key === 38 ) {
      if ( id === 0 ) {
        items.children[ items.children.length - 1 ].focus();
      } else {
        items.children[ id - 1 ].focus();
      }
    } else if ( key == 40 ) {
      if ( id === items.children.length - 1 ) {
        items.children[ 0 ].focus();
      } else {
        items.children[ id + 1 ].focus();
      }
    }
  }
}
